import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createWrapper } from 'next-redux-wrapper';

// Reducera
import geolocation from './geolocation/reducer';
import userLocation from './userLocation/reducer';
import example from './example/reducer';
import page from './page/reducer';
import metadata from './metadata/reducer';
import dataGTM from './googleTagManager/reducer';
import tasia from './tasia/reducer';
import auth from './auth/reducer';
import locationModal from './locationModal/reducer';
import defaultProvince from './defaultProvince/reducer';
import newCar from './newCar/reducer';
import servicePackage from './servicePackage/reducer';
import myAccount from './myAccount/reducer';
import bookingService from './bookingService/reducer';
import loyalty from './loyalty/reducer';
import globalCart from './globalCart/reducer';
import orderPlacement from './orderPlacement/reducer';
import emarsys from './emarsys/reducer';
import managementForm from './managementForm/reducer';
import confirmationModal from './confirmationModal/reducer';
import myGift from './myGift/reducer';
import dsr from './dsr/reducer';

const rootReducer = {
  example,
  page,
  geolocation,
  userLocation,
  metadata,
  dataGTM,
  tasia,
  auth,
  locationModal,
  defaultProvince,
  newCar,
  servicePackage,
  myAccount,
  bookingService,
  loyalty,
  globalCart,
  orderPlacement,
  emarsys,
  managementForm,
  confirmationModal,
  myGift,
  dsr,
};

const reducer = combineReducers(rootReducer);
export const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunkMiddleware)));
export type IRootState = ReturnType<typeof reducer>;

const makeStore = () => store;
export const wrapper = createWrapper(makeStore);
